import $ from "jquery";

export const Menu = function () {
	const $elms = {
		wrapper: $(".js-menu"),
		btnMenu: $(".js-menu-btn"),
		btnClose: $(".js-menu-close-btn"),
		menuItem: $(".js-menu-item"),
	};

	$($elms.btnMenu).on("click", function () {
		$($elms.wrapper).addClass("is-open");

		// $(this).hide();
	});

	$($elms.btnClose).on("click", function () {
		$($elms.wrapper).removeClass("is-open");
		// $($elms.btnMenu).show();
	});

	$($elms.menuItem).on("click", function () {
		const url = $(this).attr("data-url");
		if (url) {
			$($elms.wrapper).removeClass("is-open");
			window.location.href = url;
		}
	});
};
